export function calculateAmount(total, percent) {
  if (total == null || percent == null) {
    return null;
  }

  return percent / 100 * total;
}

export function calculatePercent(total, amount) {
  if (total == null || amount == null) {
    return null;
  }

  return total > 0 ? amount / total * 100 : 0;
}

export function updateBrokerCommissions(totalCommissionAmount, commissions) {
  commissions = [...commissions];
  let totalOutsideCommissionAmount = 0;

  for (let i = 0; i < commissions.length; i++) {
    const commission = { ...commissions[i] };

    if (commission.outside) {
      commissions[i] = updateCommission(totalCommissionAmount, commission);
      totalOutsideCommissionAmount += commission.grossAmount || 0;
    }

    commissions[i] = commission;
  }

  let internalTotal;
  if (totalCommissionAmount) {
    internalTotal = totalCommissionAmount - totalOutsideCommissionAmount;
  }

  if (!internalTotal || internalTotal < 0) {
    internalTotal = null;
  }

  for (const commission of commissions) {
    if (!commission.outside) {
      updateCommission(internalTotal, commission);
    }
  }

  return commissions;
}

function updateCommission(totalCommissionAmount, commission) {
  if (commission.grossUnit === 'gross_unit_percent') {
    commission.grossAmount = calculateAmount(totalCommissionAmount, commission.grossPercent);
  } else {
    commission.grossPercent = calculatePercent(totalCommissionAmount, commission.grossAmount);
  }
}
